/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react';
import { func, shape } from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import formatMessage from '../../format-message';
export default function LoadMoreButton({
  loader
}) {
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    padding: "small",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: loader.onLoadMore,
    variant: "default"
  }, formatMessage('Load More')));
}
LoadMoreButton.propTypes = {
  loader: shape({
    onLoadMore: func.isRequired
  }).isRequired
};